import useToggle from 'academy-common-lib/hooks/useToggle';
import MobileTopFilterPanel from '../../../containers/TracksPage/MobileTopFilterPanel';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { usePlaylistItemsSearch } from '../playlistItemsHooks';
import { FilterIcon } from 'foundations-assets/icons/components/FilterIcon';
import I18n from 'I18n';
import { useHasGate } from '../../accounts';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PlaylistMobileFilterButton = () => {
  const {
    isShowing,
    show,
    hide
  } = useToggle();
  const {
    totalCount
  } = usePlaylistItemsSearch();
  const {
    hasGate
  } = useHasGate('Academy:TrainerContent');
  const filters = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE];
  if (hasGate) {
    filters.push(FILTER_TYPES.CONTENT_SOURCE);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-label": I18n.text('learningCenter.filters.filtersLink'),
      "data-test-id": "mobile-filter-panel-button",
      onClick: show,
      size: "small",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FilterIcon, {})
    }), /*#__PURE__*/_jsx(MobileTopFilterPanel, {
      "data-test-id": "mobile-secondary-filter-panel",
      itemsCount: totalCount,
      mobileFilterTypes: filters,
      onCloseClick: hide,
      open: isShowing,
      showSort: false
    })]
  });
};